
const prefix = '' // api地址前缀
const dev = window.location.host.includes('localhost');
const http = window.location.host.startsWith('http') ? '' : 'http://'
const servers = {
    // 测试服
    'basePath': 'http://m.daniulab.com:9456/labpro',
    'defaultLogoPath': 'http://52.81.91.72:9456/labpro/upload/images/logo2.png',
    'defaultImgPath': 'http://52.81.91.72:9456/labpro/upload/images/default_img.png',
    'defaultAvatorPath': 'http://52.81.91.72:9456/labpro/upload/images/avatar_default.png',
    'defaultAvator': 'http://52.81.91.72:9456/labpro/upload/images/defaultheader.png',
    'defaultNoEmptyPath': http + window.location.host + '/labpro/upload/images/detailssss1.png',
    'defaultNoContentPath': "labpro/upload/images/details1.png",
    'defaultMsg': 'labpro/upload/images/Blankpageofbulletinboard1.png',

    // 'basePath': 'http://315lb96182.zicp.vip/labpro',
    // 'defaultLogoPath': 'http://315lb96182.zicp.vip/labpro/upload/images/logo2.png',
    // 'defaultImgPath': 'http://315lb96182.zicp.vip/labpro/upload/images/default_img.png',
    // 'defaultAvatorPath': 'http://315lb96182.zicp.vip/labpro/upload/images/avatar_default.png',
    // 'defaultAvator': 'http://315lb96182.zicp.vip/labpro/upload/images/defaultheader.png',
    // 'defaultNoEmptyPath': http + window.location.host + '/labpro/upload/images/detailssss.png',
    // 'defaultNoContentPath': "labpro/upload/images/details.png",
    // 'defaultMsg': 'labpro/upload/images/Blankpageofbulletinboard.png',
    //正式服
    // 'basePath': 'http://172.18.32.2:9456/labpro',
    // 'defaultLogoPath': 'http://172.18.32.2:9456/labpro/upload/images/logo2.png',
    // 'defaultImgPath': 'http://172.18.32.2:9456/labpro/upload/images/default_img.png',
    // 'defaultAvatorPath': 'http://52.81.91.72:9456/labpro/upload/images/avatar_default.png',
    // 'defaultAvator': 'http://52.81.91.72:9456/labpro/upload/images/defaultheader.png',
    // 'defaultNoEmptyPath': http + window.location.host + '/labpro/upload/images/detailssss.png',
    // 'defaultNoContentPath': 'labpro/upload/images/default.png',
    // 'defaultMsg': 'labpro/upload/images/Blankpageofbulletinboard.png',

    // 'basePath':'http://172.18.31.1:9456/labpro',
    // 'defaultLogoPath':'http://172.18.31.1:9456/labpro/upload/images/logo2.png',
    // 'defaultImgPath':'http://172.18.31.1:9456/labpro/upload/images/default_img.png',
    // 'defaultAvatorPath':'http://172.18.31.1:9456/labpro/upload/images/avatar_default.png',
    // 'defaultNoContentPath':'labpro/upload/images/default.png',

    // 'basePath':'http://m.daniulab.com:9456/labpro',
    // 'defaultLogoPath':'http://m.daniulab.com:9456/labpro/upload/images/logo2.png',
    // 'defaultImgPath':'http://m.daniulab.com:9456/labpro/upload/images/default_img.png',
    // 'defaultAvatorPath':'http://m.daniulab.com:9456/labpro/upload/images/avatar_default.png',
    // 'defaultNoContentPath':'labpro/upload/images/default.png',

    // 'basePath':'http://192.168.0.111/labpro',
    // 'defaultLogoPath':'http://192.168.0.111/labpro/upload/images/logo2.png',
    // 'defaultImgPath':'http://192.168.0.111/labpro/upload/images/default_img.png',
    // 'defaultAvatorPath':'http://192.168.0.111/labpro/upload/images/avatar_default.png',
    // 'defaultNoContentPath':'labpro/upload/images/default.png',

    // 'basePath':'http://localhost:8080/labpro',
    // 'defaultLogoPath':'http://localhost:8080/labpro/upload/images/logo2.png',
    // 'defaultImgPath':'http://localhost:8080/labpro/upload/images/default_img.png',
    // 'defaultAvatorPath':'http://localhost:8080/labpro/upload/images/avatar_default.png',
    // 'defaultNoContentPath':'labpro/upload/images/default.png',

    // 'basePath':'http://localhost:8456/labpro',
    // 'defaultLogoPath':'http://localhost:8456/labpro/upload/images/logo2.png',
    // 'defaultImgPath':'http://localhost:8456/labpro/upload/images/default_img.png',
    // 'defaultAvatorPath':'http://localhost:8456/labpro/upload/images/avatar_default.png',
    // 'defaultNoContentPath':'labpro/upload/images/default.png',

    // 'basePath':'http://192.168.0.111:9456/labpro',
    // 'defaultLogoPath':'http://192.168.0.111:9456/labpro/upload/images/logo2.png',
    // 'defaultImgPath':'http://192.168.0.111:9456/labpro/upload/images/default_img.png',
    // 'defaultAvatorPath':'http://192.168.0.111:9456/labpro/upload/images/avatar_default.png',
    // 'defaultNoContentPath':'labpro/upload/images/default.png',
    'http': window.location.host.startsWith('http') ? '' : 'http://',
    'labpro': '/labpro',
    'taskReport': '/labpro/appNeedToken/proManager/updateReportInfo.do',//汇报新增
    "getMember": '/labpro/appNeedToken/pcMain/getMember.do',//人员切换
    "getContactPerson": '/labpro/appNeedToken/reaManager/getNewsLinkMan',
    //联系人组管理
    'getLinkManListBylk': "/labpro/appNeedToken/reaManager/getLinkManListBylk.do",
    //经费统计
    'getExpenditure': '/labpro/appNeedToken/cwAction/getExpenditure.do',//获取顶级经费 
    'getExpenditure2': '/labpro/funds/getListName.do',//获取顶级经费 
    'ExpensesRound': '/labpro/appNeedToken/cwAction/ExpensesRound.do',//圆饼图
    'ExpensesRound2': '/labpro/funds/ExpensesRound.do',//圆饼图2
    'ExpensesaddBroken': '/labpro/appNeedToken/cwAction/ExpensesaddBroken.do',//折线图2
    'ExpensesaddBroken2': '/labpro/funds/ExpensesaddBroken.do',//折线图2
    "expenditureList": '/labpro/appNeedToken/cwAction/expenditureList.do',//圆饼图table数据
    "expenditureList2": '/labpro/funds/expenditureList.do',//圆饼图table数据
    'ExpensesBroken': '/labpro/appNeedToken/cwAction/ExpensesBroken.do',//折线图
    //首页自定义
    "updateBaseUser": '/labpro/appFree/appGuest/updateBaseUser.do',

    "initial": "/labpro/appFree/appGuest/pageIni.do",
    "refreshCheckCode": "/labpro/appFree/appGuest/getNewCheckCode.do",
    "login": "/labpro/appFree/appGuest/pcLogin.do",
    "loginOut": "/labpro/appNeedToken/common/logOut.do",
    'signLab': '/labpro/appFree/appGuest/labRegister.do',
    'signUser': '/labpro/appFree/appGuest/userRegister.do',
    'piList': '/labpro/appFree/appGuest/getPiList.do',
    "upload": "/labpro/ajaxUpload/myUpload.do",
    "switchLab": "/labpro/appNeedToken/pcMain/refreshSession.do",
    "getEqUseListCount": "labpro/appNeedToken/countPro/countListEqUseInfo.do",
    "dataList": "/labpro/appNeedToken/proManager/getDataList.do", // 2.22获取字典分类下拉
    "indexData": "/labpro/appNeedToken/proManager/getindex.do", // 2.47首页接口
    "countIndexData": "/labpro/appNeedToken/proManager/countIndex.do", // 2.50首页统计
    //获取各种下拉列表数据
    'orgListBox': '/labpro/appNeedToken/pcMain/getComboxOrgList.do',
    'labListBox': '/labpro/appNeedToken/pcMain/getComboxLabList.do',
    'RoleListBox': '/labpro/appNeedToken/pcMain/getComboxRoleList.do',
    'comboxListBox': '/labpro/appNeedToken/pcMain/getComboxTypeList.do',
    'trainUserListBox': '/labpro/appNeedToken/pcMain/getTrainUserList.do',
    'labRoleListBox': '/labpro/appNeedToken/pcMain/getLabRole.do',
    'labRoleListBox_platform': '/labpro/appNeedToken/pcMain/getComboxRoleList.do',
    // 机构
    'addOrg': "/labpro/appNeedToken/pcMain/postOrg.do",
    'orgList': "/labpro/appNeedToken/pcMain/getOrgList.do",
    'orgInfo': "/labpro/appNeedToken/pcMain/getOrgById.do",
    'orgApplyList': "/labpro/appNeedToken/eqPro/getLabList.do",
    'getLabIni': "/labpro/appNeedToken/eqPro/getLabIni.do",
    'audiLab': "/labpro/appNeedToken/eqPro/audiLab.do",
    // 实验室
    'labList': '/labpro/appNeedToken/pcMain/getLabList.do',
    'labInfo': '/labpro/appNeedToken/pcMain/getLabById.do',
    'getLab': '/labpro/appNeedToken/pcMain/getLab.do',
    'getLabUserInfo': '/labpro/appNeedToken/pcMain/getUserById.do',
    'addLab': '/labpro/appNeedToken/pcMain/postLab.do',
    'userApplyList': '/labpro/appNeedToken/eqPro/getUserList.do',
    'userApplyInfo': '/labpro/appNeedToken/eqPro/getUserIni.do',
    'userApplyAudi': '/labpro/appNeedToken/eqPro/audiUser.do',
    // 账号
    'userList': '/labpro/appNeedToken/pcMain/getUserList.do',
    'allUserList': '/labpro/appNeedToken/pcMain/getAllLabUserList.do',
    'pswReset': '/labpro/appNeedToken/pcMain/restPwd.do',
    'addUserAccount': '/labpro/appNeedToken/pcMain/postUser.do',
    'labUserList': '/labpro/appNeedToken/pcMain/getLabUserList.do',
    'getSignUserList': '/labpro/appFree/appGuest/getUserList.do',

    // 培训相关
    'trainList': '/labpro/appNeedToken/pcMain/getTrainList.do',
    'addTrain': '/labpro/appNeedToken/pcMain/postTrain.do',
    'endTrain': '/labpro/appNeedToken/pcMain/endTrain.do',
    'trainInfo': '/labpro/appNeedToken/pcMain/getTrainDetail.do',
    // 考勤
    'attendanceSettingData': '/labpro/appNeedToken/pcMain/getWorksetInfo.do',
    'addAttendance': '/labpro/appNeedToken/pcMain/postWorkSet.do',
    'attendanceList': '/labpro/appNeedToken/pcMain/getTimecardList.do',
    // 请假
    'leaveList': '/labpro/appNeedToken/pcMain/getLeaveList.do',
    'leaveInfo': '/labpro/appNeedToken/pcMain/getLeaveInfo.do',
    'auditLeave': '/labpro/appNeedToken/pcMain/auditLeave.do',
    // 个人中心
    'userEdit': '/labpro/appNeedToken/common/postUser.do',
    'suggest': '/labpro/appNeedToken/appMain/postSuggest.do',
    'suggestList': '/labpro/appNeedToken/pcMain/getSuggestList.do',
    'userAudiList': '/labpro/appNeedToken/reaManager/getAudiList.do',
    'userCredit': '/labpro/appNeedToken/eqPro/getMyCredi.do',
    // 公告
    'noticeList': '/labpro/appNeedToken/pcMain/getNoticeList.do',
    'addNotice': '/labpro/appNeedToken/pcMain/postNotice.do',
    'topNotice': '/labpro/appNeedToken/pcMain/topNotice.do',
    'delNotice': '/labpro/appNeedToken/pcMain/delNoticeById.do',
    //消息
    'msgList': '/labpro/appNeedToken/pcMain/getPcMsgList.do',
    'msgNum': '/labpro/appNeedToken/pcMain/getMsgNum.do',
    'msgNewNum': '/labpro/appNeedToken/common/getNewMsgNum.do',
    'msgUpdateInvite': '/labpro/appNeedToken/proManager/updateInvite.do',
    'msgJobInfo': '/labpro/appNeedToken/proManager/getJobInfo.do',
    'dealMsgRead': '/labpro/appNeedToken/common/dealMegRead.do',
    'proInviteInfo': '/labpro/appNeedToken/proManager/getInviteInfo.do',
    //项目管理
    'getProList': '/labpro/appNeedToken/proManager/getProList.do',
    'proInfo': '/labpro/appNeedToken/proManager/getProInfo.do',
    'getProChildList': '/labpro/appNeedToken/proManager/getProChildList.do',
    'updateColl': '/labpro/appNeedToken/proManager/updateColl.do',
    'subPro': '/labpro/appNeedToken/proManager/subPro.do',
    'getUserIdsCombox': '/labpro/appNeedToken/proManager/getUserIdsCombox.do',
    'getUserId': '/labpro/appNeedToken/proManager/getUserId.do',
    'getJobList': '/labpro/appNeedToken/proManager/getJobList.do',
    'getReportList': '/labpro/appNeedToken/proManager/getReportList.do',
    'getDocList': '/labpro/appNeedToken/proManager/getDocList.do',
    'updatedelDoc': '/labpro/appNeedToken/proManager/updatedelDoc.do',
    'updateJobState': '/labpro/appNeedToken/proManager/updateJobState.do',
    'updateurgeJob': '/labpro/appNeedToken/proManager/updateurgeJob.do',
    'subJob': '/labpro/appNeedToken/proManager/subJob.do',
    'subProState': '/labpro/appNeedToken/proManager/subProState.do',
    'updateupDoc': '/labpro/appNeedToken/proManager/updateupDoc.do',
    'getJobInfo': '/labpro/appNeedToken/proManager/getJobInfo.do',
    'updateJobDel': '/labpro/appNeedToken/proManager/updateJobDel.do',
    'updatewarnJob': '/labpro/appNeedToken/proManager/updatewarnJob.do',
    'getDocInfo': '/labpro/appNeedToken/proManager/getDocInfo.do',
    'getReportInfo': '/labpro/appNeedToken/proManager/getReportInfo.do',



    // 2.19获取审核流程列表
    'flowInfo': '/labpro/appNeedToken/proManager/getFlowInfo.do',
    'addFlow': '/labpro/appNeedToken/proManager/updateFlowInfo.do',

    // 试剂耗材
    'reaList': '/labpro/appNeedToken/reaManager/getReaList.do',
    'medicineBackIn': '/labpro/appNeedToken/reaManager/getReaInfobakIni.do',
    'medicineBackInPost': '/labpro/appNeedToken/reaManager/updateReabak.do',
    'medicineInfo': '/labpro/appNeedToken/reaManager/getReaInfo.do',
    'medicineBatchList': '/labpro/appNeedToken/reaManager/getReagentbatchList.do',
    'medicineCodeList': '/labpro/appNeedToken/reaManager/getRearecodeList.do',
    'medicineTypeInfo': '/labpro/appNeedToken/reaManager/getReaInfoByType.do',
    'medicinePost': '/labpro/appNeedToken/reaManager/updateReaInfo.do',
    'medicineInPost': '/labpro/appNeedToken/reaManager/updateReaIn.do',
    'medicineAlarm': '/labpro/appNeedToken/reaManager/updateReaAlarm.do',
    'medicineDel': '/labpro/appNeedToken/reaManager/updateReaState.do',
    'medicineGetInitial': '/labpro/appNeedToken/reaManager/getReaget.do',
    'medicineGetPost': '/labpro/appNeedToken/reaManager/updateReaGet.do',
    'medicineBuyInitial': '/labpro/appNeedToken/reaManager/getReaBuy.do',
    'medicineBuyPost': '/labpro/appNeedToken/reaManager/updateReaBuy.do',
    'medicineBadList': '/labpro/appNeedToken/reaManager/getReabatchList.do',
    'medicineBadPost': '/labpro/appNeedToken/reaManager/updateReabad.do',
    'instrumentList': '/labpro/appNeedToken/pcMain/getInstrumentList.do',
    'instrumentInfo': '/labpro/appNeedToken/pcMain/getInstrumentById.do',
    'instrumentPost': '/labpro/appNeedToken/pcMain/postInstrument.do',
    'instrumentDel': '/labpro/appNeedToken/pcMain/delInstrument.do',

    //申领审批
    'audiGetList': '/labpro/appNeedToken/reaManager/getAudiGetList.do',
    'audiGetInfo': '/labpro/appNeedToken/reaManager/getAudiGetInfo.do',
    'audiGetPost': '/labpro/appNeedToken/reaManager/updateReagetAudiGet.do',
    'audiGetSee': '/labpro/appNeedToken/reaManager/getAudiGetSee.do',

    //申购审批
    'audiBuyList': '/labpro/appNeedToken/reaManager/getAudiBuyList.do',
    'audiBuyInfo': '/labpro/appNeedToken/reaManager/getAudiBuyInfo.do',
    'audiBuyPost': '/labpro/appNeedToken/reaManager/updateReagetAudiBuy.do',

    // 统计
    'staticProTime': '/labpro/appNeedToken/countPro/realTimeCount.do',
    'staticProList': '/labpro/appNeedToken/countPro/getProList.do',
    'staticProFinishPer': '/labpro/appNeedToken/countPro/proFinishPer.do',
    'staticProTaskOrMember': '/labpro/appNeedToken/countPro/userInfo.do',
    'staticProRealInfo': '/labpro/appNeedToken/countPro/reaInfo.do',
    'staticProFinishPro': '/labpro/appNeedToken/countPro/getProFinshPer.do',
    'staticProExpiryRate': '/labpro/appNeedToken/countPro/proExpiryRate.do',
    'staticProOrTaskInfo': '/labpro/appNeedToken/countPro/proJobInfo.do',

    'staticPersonWeekAtt': '/labpro/appNeedToken/common/getWeekAttendanceList.do',
    'staticPersonMonthList': '/labpro/appNeedToken/common/getMonthOrderList.do',
    'staticPersonMonthTableList': '/labpro/appNeedToken/common/getMonthList.do',

    'staticReaList': '/labpro/appNeedToken/countPro/getReaList.do',
    'staticReaInfoByMonth': '/labpro/appNeedToken/countPro/reaInfoByMonth.do',
    'staticRealListByMonth': '/labpro/appNeedToken/countPro/reaList.do',
    'staticReaInfo': '/labpro/appNeedToken/countPro/getReaInfo.do',


    'addImportReagent': '/labpro/appNeedToken/reaManager/addImportReagent.do',
    'addImportIns': '/labpro/appNeedToken/reaManager/addImportIns.do',
    'getLinkUserList': '/labpro/appNeedToken/reaManager/getLinkUserList.do',
    'addUserLink': '/labpro/appNeedToken/reaManager/updateLinkInfo.do',
    'getLinkUserInfo': '/labpro/appNeedToken/reaManager/getLinkUserInfo.do',
    'deleteLinkInfo': '/labpro/appNeedToken/reaManager/deleteLinkInfo.do',
    'getLinkGroupList': '/labpro/appNeedToken/reaManager/getLinkGroupList.do',
    'addUserGroup': '/labpro/appNeedToken/reaManager/addUserGroup.do',
    'getLinkGroupInfo': '/labpro/appNeedToken/reaManager/getLinkGroupInfo.do',
    'deleteGroupInfo': '/labpro/appNeedToken/reaManager/deleteGroupInfo.do',
    'subHarvest': '/labpro/appNeedToken/proManager/addHarvest.do',
    'getProjectTree': '/labpro/appNeedToken/proManager/getProjectTree.do',
    'getHarvestList': '/labpro/appNeedToken/proManager/getHarvestList.do',
    'getHarvestInfo': '/labpro/appNeedToken/proManager/getHarvestInfo.do',
    'deleteHarvest': '/labpro/appNeedToken/proManager/deleteHarvest.do',

    // 设备
    'eqAdminList': '/labpro/appNeedToken/eqPro/getEqList.do',
    'eqAdminInfo': '/labpro/appNeedToken/eqPro/getEqObj.do',
    'eqAdminAdd': '/labpro/appNeedToken/eqPro/submitEqObj.do',
    'eqAdminDel': '/labpro/appNeedToken/eqPro/delEqObj.do',
    'eqAdminStEdit': '/labpro/appNeedToken/eqPro/updateEqState.do',
    'eqAdminImport': '/labpro/appNeedToken/eqPro/impEq.do',
    'eqAdminRepair': '/labpro/appNeedToken/eqPro/getrepairList.do',
    'eqAdminUse': '/labpro/appNeedToken/eqPro/getuseList.do',
    'eqAppointList': '/labpro/appNeedToken/eqPro/getBeEqList.do',
    'eqAppointInfo': '/labpro/appNeedToken/eqPro/getBeEqObj.do',
    'eqAppointBeList': '/labpro/appNeedToken/eqPro/getBeList.do',
    'eqAppointApply': '/labpro/appNeedToken/eqPro/submitEqOrder.do',
    'eqAuditList': '/labpro/appNeedToken/eqPro/getEqOrderList.do',
    'eqAudit': '/labpro/appNeedToken/eqPro/audiEqOrder.do',
    'eqAuditInfo': '/labpro/appNeedToken/eqPro/getEqOrder.do',
    'eqUserAppointList': '/labpro/appNeedToken/eqPro/getMyEqOrderList.do',
    'eqUserAppointInfo': '/labpro/appNeedToken/eqPro/getBeEqOrder.do',
    'eqUserAppointConcel': '/labpro/appNeedToken/eqPro/eqOrderCan.do',
    'receiveAppoint': '/labpro/appNeedToken/eqPro/eqReceive.do',
    'eqUserUse': '/labpro/appNeedToken/eqPro/getUserEqOrderList.do',
    'eqUserUseReturn': '/labpro/appNeedToken/eqPro/userEqOrder.do',
    'eqUserUseEvalute': '/labpro/appNeedToken/eqPro/evaEqOrder.do',

    // 问卷
    'voteList': '/labpro/appNeedToken/eqPro/getVoteList.do',
    'voteInfo': '/labpro/appNeedToken/eqPro/getVoteInfo.do',
    'voteStatic': '/labpro/appNeedToken/eqPro/getVoteObj.do',
    'voteSubmit': '/labpro/appNeedToken/eqPro/submitVote.do',
    'voteSub': '/labpro/appNeedToken/eqPro/subVote.do',
    'voteDel': '/labpro/appNeedToken/eqPro/delVote.do',
    'voteMyList': '/labpro/appNeedToken/eqPro/getMyVote.do',

    // 统计
    'stEqInfo': '/labpro/appNeedToken/countPro/beEqInfo.do',
    'stEqTop': '/labpro/appNeedToken/countPro/beEqTopTen.do',
    'stEqAppointOut': '/labpro/appNeedToken/countPro/beEqInfoByType.do',
    'stEqAppointTop': '/labpro/appNeedToken/countPro/beEqTopTenByType.do',
    'stEqUseTimeTop': '/labpro/appNeedToken/countPro/beEqTopTenByHour.do',
    'stEqUseInfoTop': '/labpro/appNeedToken/countPro/useEqInfo.do',
    'stEqBadInfoTop': '/labpro/appNeedToken/countPro/eqInfoByYear.do',
    'stUserCreditInfo': '/labpro/appNeedToken/countPro/creditInfo.do',
    'stPiCreditInfo': '/labpro/appNeedToken/countPro/creditInfoByPi.do',

    //课题组
    'getPiList': '/labpro/appNeedToken/eqPro/getPiList.do',
    'addPi': '/labpro/appNeedToken/eqPro/addPi.do',
    'getPiInfo': '/labpro/appNeedToken/eqPro/getPiInfo.do',
    'deletePi': '/labpro/appNeedToken/eqPro/deletePi.do',
    'addImportUser': '/labpro/appNeedToken/pcMain/addImportUser.do',
    'getPiUserListByPi': '/labpro/appNeedToken/pcMain/getPiUserListByPi.do',
    'delUser': '/labpro/appNeedToken/pcMain/deleteUserById.do',
    'piGetInitial': '/labpro/appNeedToken/eqPro/getPiByUserId.do',
    'getUsingPrince': '/labpro/appNeedToken/eqPro/statisticEqRental.do',
    //故障申报
    'repairList': '/labpro/appNeedToken/eqPro/repairListByUser.do',
    'repairInfo': '/labpro/appNeedToken/eqPro/repairGetId.do',
    'addRepair': '/labpro/appNeedToken/eqPro/repairSave.do',
    'delRepair': '/labpro/appNeedToken/eqPro/repairDelete.do',
    'repairAdmin': '/labpro/appNeedToken/eqPro/repairListByAffirm.do',
    'repairAffirm': '/labpro/appNeedToken/eqPro/repairAffirm.do',
    'repairFeedback': '/labpro/appNeedToken/eqPro/repairFeedback.do',
    'dealAllMsgReadPost': '/labpro/appNeedToken/eqPro/readAllMsgByUser.do',
    'getStRepairInfo': '/labpro/appNeedToken/eqPro/repairStatistic.do',

    // 报账
    'getCWList': '/labpro/appNeedToken/cwAction/cwProjectList.do',
    'cwUpdate': '/labpro/appNeedToken/cwAction/cwProjectUpdate.do',
    //有点问题
    'getCWInit': '/labpro/appNeedToken/appPro/cwProjectIni.do',
    'cwCopy': '/labpro/appNeedToken/cwAction/cwProjectCopy.do',
    'getCWProjectSelect': '/labpro/appNeedToken/cwAction/cwProjectSelect.do',
    'getCWManagerSelect': '/labpro/appNeedToken/cwAction/cwManagerSelect.do',
    'getCWOpList': '/labpro/appNeedToken/cwAction/cwOpList.do',
    'cwOpSubmit': '/labpro/appNeedToken/cwAction/cwOp.do',
    'getCWAllName': '/labpro/appNeedToken/cwAction/cwProjectName.do',
    'getCWReqList': '/labpro/appNeedToken/cwAction/cwReqList.do',
    'getCWSelfReqList': '/labpro/appNeedToken/cwAction/cwSelfReqList.do',
    'cwReq': '/labpro/appNeedToken/cwAction/cwReq.do',
    'getCWReqInit': '/labpro/appNeedToken/cwAction/cwReqIni.do',
    'getCWType': '/labpro/appNeedToken/cwAction/cwType.do',
    'cwsubmit': '/labpro/appNeedToken/cwAction/cwsubmit.do',
    'getCWAuditList': '/labpro/appNeedToken/cwAction/cwaudiList.do',
    'cwCancel': '/labpro/appNeedToken/cwAction/cwCanl.do',
    'getCWAuditInit': '/labpro/appNeedToken/cwAction/cwaudiIni.do',
    'cwAudit': '/labpro/appNeedToken/cwAction/cwaudi.do',
    'getCWPageList': '/labpro/appNeedToken/cwAction/cwpageList.do',
    'getCWPageInit': '/labpro/appNeedToken/cwAction/cwpageIni.do',
    'cwAuditCancel': '/labpro/appNeedToken/cwAction/cwreqcan.do',
    'cwAuditDel': '/labpro/appNeedToken/cwAction/cwReqDel.do',

    // 私盘
    'getDiskTree': '/labpro/appNeedToken/pdDisk/space/folder/tree/get.do',
    'getDiskFiles': '/labpro/appNeedToken/pdDisk/folder/files/get.do',
    'postDiskFiles': '/labpro/appNeedToken/pdDisk/folder/files/get.do',
    'createDiskTree': '/labpro/appNeedToken/pdDisk/folder/post.do',
    'clearDiskTree': '/labpro/appNeedToken/pdDisk/folder/clear/delete.do',
    'delDiskTree': '/labpro/appNeedToken/pdDisk/folders/delete.do',
    'getDiskTreeInfo': '/labpro/appNeedToken/pdDisk/folder/detail/get.do',
    'modifyDiskTreeInfo': '/labpro/appNeedToken/pdDisk/folder/put.do',
    'diskFilesUpload': '/labpro/appNeedToken/pdDisk/folder/files/post.do',
    'diskFileShare': '/labpro/appNeedToken/pdDisk/folder/file/share/post.do',
    'diskFilesDel': '/labpro/appNeedToken/pdDisk/files/delete.do',
    'diskFilesDown': '/labpro/appNeedToken/pdDisk/folder/files/download/get.do',
    'getDiskFileInfo': '/labpro/appNeedToken/pdDisk/folder/file/get.do',
    'diskFilesReUpload': '/labpro/appNeedToken/pdDisk/folder/file/put.do',
    'getGroupDiskApplication': '/labpro/appNeedToken/pdDisk/pdReqs/get.do',
    'groupDiskApply': '/labpro/appNeedToken/pdDisk/pdReq/post.do',
    'getGroupDiskAppInfo': '/labpro/appNeedToken/pdDisk/pdReq/get.do',
    'groupDiskAudit': '/labpro/appNeedToken/pdDisk/pdReq/audit/put.do',
    'groupDiskApplyModify': '/labpro/appNeedToken/pdDisk/pdReq/put.do',
    'diskSpaceStatics': '/labpro/appNeedToken/pdDisk/statistics/get.do',
    'diskSpaceSubmit': '/labpro/appNeedToken/pdDisk/put.do',
    'diskSpaceInfo': '/labpro/appNeedToken/pdDisk/space/group/get.do',
    'getDiskSpaceeList': '/labpro/appNeedToken/pdDisk/spaces/get.do',
    'clearSpace': '/labpro/appNeedToken/pdDisk/space/clear/delete.do',
    'delSpace': '/labpro/appNeedToken/pdDisk/space/delete.do',
    'modifySpace': '/labpro/appNeedToken/pdDisk/space/put.do',
    'shareFileDel': '/labpro/appNeedToken/pdDisk/folder/file/share/delete.do',

    // 年报管理
    'getAnnualReports': '/labpro/appNeedToken/annualReport/pis/get.do',
    'getAnnualReportSettings': '/labpro/appNeedToken/annualReport/get.do',
    'annualReportSetting': '/labpro/appNeedToken/annualReport/post.do',
    'annualReportsUrge': '/labpro/appNeedToken/annualReport/message/post.do',
    'annualReportUrge': '/labpro/appNeedToken/annualReport/pi/message/post.do',
    'annualReportDataImport': '/labpro/appNeedToken/annualReport/pi/datas/post.do',
    'getAnnualReportDatas': '/labpro/appNeedToken/annualReport/pi/datas/get.do',
    'annualReportDataDel': '/labpro/appNeedToken/annualReport/pi/datas/delete.do',
    'annualReportModify': '/labpro/appNeedToken/annualReport/pi/put.do',
    'annualReportModify1': '/labpro/appNeedToken/annualReport/pi/changeStatus.do',
    'annualReportInfo': '/labpro/appNeedToken/annualReport/pi/get.do',
    'annualReportProgressSubmit': '/labpro/appNeedToken/annualReport/pi/data/progress/post.do',
    'annualReportResultUpload': '/labpro/appNeedToken/annualReport/pi/data/files/post.do',
    'annualReportImport': '/labpro/appNeedToken/annualReport/pi/all/datas/post.do',
    'annualReportsExport': '/labpro/appNeedToken/annualReport/multiple/download/get.do',
    'annualReportExport': '/labpro/appNeedToken/annualReport/pi/download/get.do',
    'annualReportResultFileDel': '/labpro/appNeedToken/annualReport/pi/data/files/delete.do',
    'modeList': '/labpro/appFree/appGuest/getModeList.do',
    'addxy': '/labpro/appNeedToken/eqPro/addxy.do',
    'delxy': '/labpro/appNeedToken/eqPro/delxy.do',
    'xyrewrite': '/labpro/appNeedToken/eqPro/xyrewrite.do',
    'getPiEqInfo': '/labpro/appNeedToken/eqPro/getPiEqInfo.do',
    //报告管理
    'dataListmy': '/labpro/nReport/dataList',
    'getId': '/labpro/nReport/getId',
    'reportUpdate': '/labpro/nReport/update',
    'reportUser': '/labpro/reportUser/dataList',
    'reportUserpost': '/labpro/reportUser/message/post',
    'review': '/labpro/sysUser/selectBycomma',
    'save': '/labpro/nReport/save',
    'reportUsergetId': '/labpro/reportUser/getId',
    'reportSave': '/labpro/reportUserDetails/save',
    'reportSubmit': '/labpro/reportUserDetails/submit',
    'importReport': '/labpro/reportUser/importReport',
    'checkMy': '/labpro/reportUser/check',
    'findTypes': '/labpro/nReport/findTypes',
    'findReportCategorys': '/labpro/nReport/findReportCategorys',
    'findNames': '/labpro/nReport/findNames',
    'queryByName': '/labpro/nReport/queryByName',
    'DeleteSave': '/labpro/reportUser/save',
    "exportType": '/labpro/reportUser/export',//报告导出
    'downloadReport': '/labpro/reportUser/download',//模板下载
    //经费报账
    'fundsdataList': '/labpro/funds/dataList',
    'getOpenProject': '/labpro/appNeedToken/proManager/getOpenProject',//经费创建
    'fundsSave': '/labpro/funds/save',
    'fundsGetId': '/labpro/funds/getId',
    'fundsList': '/labpro/funds/fundsList',
    'getIdByedit': '/labpro/funds/getIdByedit',//经费编辑
    'getsonIdByedit': '/labpro/funds/getsonIdByedit',
    'fundsAllot': '/labpro/funds/allot',
    'updateallot': '/labpro/funds/updateallot',
    'findSuccessDetail': '/labpro/fundsApply/findSuccessDetail',
    'changeStatus': '/labpro/funds/changeStatus',//开启关闭
    'fundsApplyGetId': '/labpro/fundsApply/getId',
    'findMyPojoList': '/labpro/fundsApply/findMyPojoList',//我的报账
    'fundsGetList': '/labpro/funds/getList',
    'findByfundsId': '/labpro/auditForfunds/findByfundsId',
    'fundsApplySave': '/labpro/fundsApply/save',
    'withdraw': '/labpro/fundsApply/withdraw',//撤回
    'DeleteAndaudit': '/labpro/fundsApply/deleteAndaudit',//删除
    'invoiceFindPojoList': '/labpro/invoice/findPojoList',//发票单据库
    'auditForfundsLogFindByAudit': '/labpro/auditForfundsLog/findByAudit',//审批页面
    'updateBySubmit': '/labpro/fundsApply/updateBySubmit',//提交
    'auditForfundsLogAudit': '/labpro/auditForfundsLog/audit',
    'updateAuditAgain': "/labpro/auditForfundsLog/updateAuditAgain",
    'fundsDelete': '/labpro/funds/delete',//经费删除
    'auditForfundsLog': '/labpro/auditForfundsLog/delete',//审批删除
    'invoiceDelete': '/labpro/invoice/delete',//发票库删除
    'invoiceGetDetailId': '/labpro/invoice/getDetailId',//发票单据详情
    'invoiceDn': '/labpro/invoice/download',//导出  
    'getByCode': '/labpro/invoice/getByCode',//code光标离开触发
    'getTypeMy': '/labpro/appNeedToken/proManager/getType',


    'checkReport': '/labpro/appNeedToken/proManager/checkReport',
    'workReportDataList': '/labpro/workReport/dataList',
    'workReportUserDataList': '/labpro/workReportUser/dataList',
    'findsubjectByType': '/labpro/workReport/findsubjectType',
    'workReportSave': '/labpro/workReport/save',//创建汇报
    'workgetReportList': '/labpro/workReport/getReportList',//子汇报
    'workReportGetId': '/labpro/workReport/getId',
    'workReportUserGetId': '/labpro/workReportUser/getId',
    'workReportCui': '/labpro/workReport/message/post',
    'workReportDelete': '/labpro/workReport/delete',
    'findsubjectById': 'labpro/workReport/findsubjectById',
    'workReportUserSave': '/labpro/workReportUser/save',
    'workReportUserDeleteList': "/labpro/workReportUser/delete",
    'workReportUserCuiban': '/labpro/workReportUser/message/post',
    'includeType': 'labpro/achievementPaper/includeType',
    'achievementPaper': 'labpro/achievementPaper/save',//论文
    'achievementPaperGetId': 'labpro/achievementPaper/getId',//论文详情
    'achievementPatent': 'labpro/achievementPatent/save',//专利
    'achievementPatentGetId': 'labpro/achievementPatent/getId',//专利详情   
    'achievementAward': 'labpro/achievementAward/save',//获奖
    'achievementAwardgetId': 'labpro/achievementAward/getId',//获奖详情
    'achievementNews': 'labpro/achievementNews/save',//新品种
    'achievementNewsgetId': 'labpro/achievementNews/getId',//新品种详情
    'achievementCopyright': 'labpro/achievementCopyright/save',//著作权
    'achievementCopyrightgetId': 'labpro/achievementCopyright/getId',//著作权详情
    'achievementAuthenticate': 'labpro/achievementAuthenticate/save',//成果鉴定
    'achievementAuthenticategetId': 'labpro/achievementAuthenticate/getId',//成果鉴定详情
    'achievementMedicine': 'labpro/achievementMedicine/save',//药证
    'achievementMedicinegetId': 'labpro/achievementMedicine/getId',//药证详情
    'achievementDataList': '/labpro/achievement/dataList',
    'findrank': '/labpro/achievementAward/findrank',
    'academicMeetingDataList': '/labpro/academicMeeting/dataList',
    'academicMeetingSave': 'labpro/academicMeeting/save',
    'academicMeetingGetId': 'labpro/academicMeeting/getId',
    'achievementDelete': '/labpro/achievement/delete',
    'academicMeetingDelete': '/labpro/academicMeeting/delete',
    'importup': '/labpro/reportUser/export',// 报告管理导出
    'unfinishedPeople': '/labpro/unfinished/dataList',//待完成接口
    'deletePro': '/labpro/appNeedToken/proManager/deletePro',
    'deleteJob': '/labpro/appNeedToken/proManager/deleteJob',
    'deleteReport': '/labpro/appNeedToken/proManager/deleteReport',

    'informdataList': '/labpro/inform/dataList',
    'informsave': 'labpro/inform/save',
    'informdelete': 'labpro/inform/delete',
    'informgetPojoId': 'labpro/inform/getPojoId',
    'informgetId': 'labpro/inform/getId',
    'informmessage': 'labpro/inform/message',

    'auditForfundsLogOut': 'labpro/auditForfundsLog/download',//审批导出

    //全局搜索
    'allSearch': '/labpro/appNeedToken/appPro/getInfoByWebSeach',
    'downloadData': '/labpro/appNeedToken/proManager/downloadData',
    'delSuggest': '/labpro/appNeedToken/appMain/delSuggest',
    'fristTO': '/labpro/appNeedToken/pcMain/getnoFinishNum',
    'repairListByUser': "/labpro/appNeedToken/eqPro/repairListByUser",
    'backEqNoYY': '/labpro/appNeedToken/eqPro/backEqNoYY',
    'delTrain': '/labpro/appNeedToken/pcMain/delTrain',
    'delUserRecord': '/labpro/appNeedToken/eqPro/delUserRecord',

    'backlogTagDataList': '/labpro/backlogTag/dataList',
    'backlogTagSave': '/labpro/backlogTag/save',
    'backlogTagChangeSite': '/labpro/backlogTag/changeSite',
    'backlogTagDelete': "labpro/backlogTag/delete",
    'backlogListSave': 'labpro/backlogList/save',
    'backlogListDelete': "labpro/backlogList/delete",
    'backlogListDataList': 'labpro/backlogList/dataList',
    'backlogTagGetTagName': 'labpro/backlogTag/getTagName',
    'backlogListUpdateTagBatch': "labpro/backlogList/updateTagBatch",
    'backlogListUndone': 'labpro/backlogList/undone',
    'getEqclassify': 'labpro/appNeedToken/eqPro/getEqclassify',


    'querySingleTotal': '/labpro/projectInfo/querySingleTotal',
    'querypluralTotal': '/labpro/projectInfo/querypluralTotal',
    'querypluralTotalavg': '/labpro/projectInfo/querypluralTotalavg',
    'subjectType': '/labpro/projectInfo/subjectType',
    'querySupportProject': '/labpro/projectInfo/querySupportProject',
    'queryDetails': '/labpro/projectInfo/queryDetails',

     //删除msg的9999数据
     'delMessage': '/labpro/appNeedToken/pcMain/delMessage'
}

export default servers;


